<template>
  <div id="bd-custom">
    <el-form ref="iconForm" label-width="280px">
      <el-form-item label="对话类型">
        <el-radio-group v-model="type">
          <el-radio label="workGroup">技能组对话</el-radio>
          <el-radio label="appointed">指定一对一对话</el-radio>
        </el-radio-group>
        <span class="param">参数：type，值：workGroup, appointed</span>
      </el-form-item>
      <el-form-item label="技能组" v-if="type === 'workGroup'">
        <el-radio-group v-model="workGroupWid" @change="reinit">
          <el-radio
            v-for="workGroup in workGroups"
            :label="workGroup.wid"
            :key="workGroup.wid"
            >{{ workGroup.nickname }}</el-radio
          >
        </el-radio-group>
        <span class="param">参数：wid/workGroupWid</span>
      </el-form-item>
      <el-form-item label="指定客服" v-if="type === 'appointed'">
        <el-radio-group v-model="agentUid" @change="reinit">
          <el-radio
            v-for="agent in agents"
            :label="agent.uid"
            :key="agent.uid"
            >{{ agent.nickname }}</el-radio
          >
        </el-radio-group>
        <span class="param">参数：aid/agentUid</span>
      </el-form-item>
      <el-form-item label="漂浮框形状">
        <el-radio-group v-model="shape" @change="reinit">
          <el-radio label="round">圆形</el-radio>
          <el-radio label="rectangle">长方形</el-radio>
        </el-radio-group>
        <span class="param">参数：shape</span>
      </el-form-item>
      <el-form-item label="漂浮框按钮文字" v-if="shape === 'rectangle'">
        <el-input
          v-model="buttonText"
          placeholder="请输入内容"
          style="width: 220px;"
        ></el-input>
        <el-button size="medium" round @click="reinit">更新</el-button>
        <span class="param">参数：buttonText</span>
      </el-form-item>
      <el-form-item label="漂浮框/对话框标题文字颜色">
        <el-color-picker v-model="buttonColor"></el-color-picker>
        <span class="param">参数：buttonColor/bannerColor</span>
      </el-form-item>
      <el-form-item label="漂浮框背景颜色">
        <el-color-picker v-model="buttonBackground"></el-color-picker>
        <span class="param">参数：buttonBackground/buttonBackground</span>
      </el-form-item>
      <el-form-item label="漂浮框位置">
        <el-radio-group v-model="position" @change="reinit">
          <el-radio label="right">右边</el-radio>
          <el-radio label="left">左边</el-radio>
        </el-radio-group>
        <span class="param">参数：position</span>
      </el-form-item>
      <el-form-item label="漂浮框右边距离" v-if="position === 'right'">
        <el-radio-group v-model="rightMargin" @change="reinit">
          <el-radio label="10">10px</el-radio>
          <el-radio label="15">15px</el-radio>
          <el-radio label="20">20px</el-radio>
          <el-radio label="25">25px</el-radio>
          <el-radio label="30">30px</el-radio>
          <el-radio label="40">40px</el-radio>
          <el-radio label="50">50px</el-radio>
          <el-radio label="60">60px</el-radio>
          <el-radio label="70">70px</el-radio>
          <el-radio label="80">80px</el-radio>
          <el-radio label="90">90px</el-radio>
          <el-radio label="100">100px</el-radio>
        </el-radio-group>
        <span class="param">参数：rightMargin</span>
      </el-form-item>
      <el-form-item label="漂浮框左边距离" v-if="position === 'left'">
        <el-radio-group v-model="leftMargin" @change="reinit">
          <el-radio label="10">10px</el-radio>
          <el-radio label="15">15px</el-radio>
          <el-radio label="20">20px</el-radio>
          <el-radio label="25">25px</el-radio>
          <el-radio label="30">30px</el-radio>
          <el-radio label="40">40px</el-radio>
          <el-radio label="50">50px</el-radio>
          <el-radio label="60">60px</el-radio>
          <el-radio label="70">70px</el-radio>
          <el-radio label="80">80px</el-radio>
          <el-radio label="90">90px</el-radio>
          <el-radio label="100">100px</el-radio>
        </el-radio-group>
        <span class="param">参数：leftMargin</span>
      </el-form-item>
      <el-form-item label="漂浮框下边距离">
        <el-radio-group v-model="bottomMargin" @change="reinit">
          <el-radio label="10">10px</el-radio>
          <el-radio label="15">15px</el-radio>
          <el-radio label="20">20px</el-radio>
          <el-radio label="25">25px</el-radio>
          <el-radio label="30">30px</el-radio>
          <el-radio label="40">40px</el-radio>
          <el-radio label="50">50px</el-radio>
          <el-radio label="60">60px</el-radio>
          <el-radio label="70">70px</el-radio>
          <el-radio label="80">80px</el-radio>
          <el-radio label="90">90px</el-radio>
          <el-radio label="100">100px</el-radio>
        </el-radio-group>
        <span class="param">参数：bottomMargin</span>
      </el-form-item>
      <el-form-item label="对话窗口宽度">
        <el-radio-group v-model="column" @change="reinit">
          <el-radio label="one">一列</el-radio>
          <el-radio label="two">两列</el-radio>
        </el-radio-group>
        <span class="param">参数：column</span>
      </el-form-item>
      <el-form-item label="历史记录">
        <el-radio-group v-model="history" @change="reinit">
          <el-radio label="0">不显示</el-radio>
          <el-radio label="1">显示</el-radio>
        </el-radio-group>
        <span class="param">参数：history</span>
      </el-form-item>
      <el-form-item label="自定义用户名" v-if="isDebug">
        <el-checkbox v-model="selfDefine">自定义用户名、昵称、头像</el-checkbox>
      </el-form-item>
      <el-form-item label="测试用户" v-if="selfDefine">
        <el-radio-group v-model="userSwitch" @change="switchTestUser">
          <el-radio label="boy">测试用户1男</el-radio>
          <el-radio label="girl">测试用户2女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="用户名" v-if="selfDefine">
        <el-input
          v-model="username"
          placeholder="请输入用户名"
          style="width: 220px;"
        ></el-input>
        <span class="param">参数：username</span>
      </el-form-item>
      <el-form-item label="昵称" v-if="selfDefine">
        <el-input
          v-model="nickname"
          placeholder="请输入昵称"
          style="width: 220px;"
        ></el-input>
        <span class="param">参数：nickname</span>
      </el-form-item>
      <el-form-item label="头像" v-if="selfDefine">
        <el-input
          v-model="avatar"
          placeholder="请输入头像网址"
          style="width: 220px;"
        ></el-input>
        <span class="param">参数：avatar</span>
        <el-image
          :src="avatar"
          :preview-src-list="[avatar]"
          style="width: 40px; height: 40px;"
        />
      </el-form-item>
      <el-form-item label="商品参数" v-if="isDebug">
        <el-checkbox v-model="showGoods">商品参数</el-checkbox>
      </el-form-item>
      <el-form-item label="商品id" v-if="showGoods">
        <el-input
          v-model="goods_id"
          placeholder="请输入商品id"
          style="width: 220px;"
        ></el-input>
        <span class="param">参数：goods_id</span>
      </el-form-item>
      <el-form-item label="商品标题" v-if="showGoods">
        <el-input
          v-model="goods_title"
          placeholder="请输入商品标题"
          style="width: 220px;"
        ></el-input>
        <span class="param">参数：goods_title</span>
      </el-form-item>
      <el-form-item label="商品简介" v-if="showGoods">
        <el-input
          v-model="goods_content"
          placeholder="请输入商品简介"
          style="width: 220px;"
        ></el-input>
        <span class="param">参数：goods_content</span>
      </el-form-item>
      <el-form-item label="商品价格" v-if="showGoods">
        <el-input
          v-model="goods_price"
          placeholder="请输入商品价格"
          style="width: 220px;"
        ></el-input>
        <span class="param">参数：goods_price</span>
      </el-form-item>
      <el-form-item label="商品网址" v-if="showGoods">
        <el-input
          v-model="goods_url"
          placeholder="请输入商品网址"
          style="width: 220px;"
        ></el-input>
        <span class="param">参数：goods_url</span>
      </el-form-item>
      <el-form-item label="商品图片" v-if="showGoods">
        <el-input
          v-model="goods_imageUrl"
          placeholder="请输入商品图片"
          style="width: 220px;"
        ></el-input>
        <span class="param">参数：goods_imageUrl</span>
        <el-image
          :src="goods_imageUrl"
          :preview-src-list="[goods_imageUrl]"
          style="width: 40px; height: 40px;"
        />
      </el-form-item>
      <el-form-item label="商品类别代码(可选)" v-if="showGoods">
        <el-input
          v-model="goods_categoryCode"
          placeholder="请输入商品类别代码"
          style="width: 220px;"
        ></el-input>
        <span class="param">参数：goods_goods_categoryCode</span>
      </el-form-item>
      <el-form-item label="自动弹窗">
        <el-checkbox v-model="autoPop" @change="reinit">自动弹窗</el-checkbox>
        <span class="param">参数：autoPop</span>
      </el-form-item>
      <el-form-item label="嵌入式窗口客服代码">
        <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="embedCode"
          style="width: 600px;"
        ></el-input>
        <p>复制客服代码，放到自己网页的&lt;/body&gt;标签前面</p>
        <el-button
          class="copyEmbedBtn"
          size="medium"
          round
          :data-clipboard-text="embedCode"
          @click="handleOnCodeEmbedCopy"
          >复制客服代码</el-button
        >
      </el-form-item>
      <el-form-item label="PC大窗口客服代码">
        <el-input
          type="textarea"
          placeholder="请输入内容"
          style="width: 600px;"
          v-model="bigWinCode"
        >
        </el-input
        ><br />
        <el-button
          class="copyBigBtn"
          size="medium"
          round
          :data-clipboard-text="bigWinCode"
          @click="handleOnCodeBigCopy"
          >复制客服代码</el-button
        >
        <el-button size="medium" round @click="openWindowBig">预览1</el-button>
        <el-button size="medium" round @click="openWindowBig2">预览2</el-button>
      </el-form-item>
      <el-form-item label="PC小窗口客服代码">
        <el-input
          type="textarea"
          placeholder="请输入内容"
          style="width: 600px;"
          v-model="smallWinCode"
        >
        </el-input
        ><br />
        <el-button
          class="copySmallBtn"
          size="medium"
          round
          :data-clipboard-text="smallWinCode"
          @click="handleOnCodeSmallCopy"
          >复制客服代码</el-button
        >
        <el-button size="medium" round @click="openWindowSmall"
          >预览1</el-button
        >
        <el-button size="medium" round @click="openWindowSmall2"
          >预览2</el-button
        >
      </el-form-item>
      <el-form-item label="H5客服代码">
        <el-input
          type="textarea"
          placeholder="请输入内容"
          style="width: 600px;"
          v-model="h5Code"
        >
        </el-input
        ><br />
        <el-button
          class="copyH5Btn"
          size="medium"
          round
          :data-clipboard-text="h5Code"
          @click="handleOnCodeH5Copy"
          >复制客服代码</el-button
        >
        <el-button size="medium" round @click="openH5">预览1</el-button>
        <el-button size="medium" round @click="openH52">预览2</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import { mapGetters, mapActions } from 'vuex'

export default {
  name: "bd-custom",
  data() {
    return {
      // fullscreenLoading: false,
      // byteDesk 属性
      style: 1, // 三个值可选：1,2,3
      border: "none", // 'border' 或 'none'
      shape: "round", // 'round' 或 'rectangle'
      //
      position: "right", // 'left' 或 'right'
      rightMargin: "50",
      leftMargin: "50",
      bottomMargin: "50",
      // 列
      column: "one",
      history: "0",
      // 对话窗口
      bannerBackground: "#007bff", // 暂时使用buttonBackground替代
      bannerColor: "#ffffff", // 暂时使用buttonColor替代
      // icon
      buttonColor: "#ffffff",
      buttonBackground: "#007bff",
      buttonText: "在线客服",
      // 客服参数
      adminUid: "", // 201808221551193
      subDomain: "", // vip
      type: "workGroup", // workGroup/appointed
      workGroupWid: "", // 201807171659201
      agentUid: "",
      // 自定义用户名、昵称、头像
      selfDefine: false,
      userSwitch: "boy",
      username: "mywebuserboy", // 自定义用户名
      nickname: "我是帅哥web", // 自定义昵称
      avatar: "https://bytedesk.oss-cn-shenzhen.aliyuncs.com/avatars/boy.png", // 自定义头像
      // 商品参数
      showGoods: false,
      // goods: "0", // goods 是否显示商品信息，如果要显示，设置为goods=1，设置为其他值，则不显示商品信息
      goods_id: "1", // goods_id 商品信息id，参数goods=1的情况有效
      goods_title: "商品标题", // goods_title 商品信息标题，参数goods=1的情况有效
      goods_content: "商品详情", // goods_content 商品信息详情，参数goods=1的情况有效
      goods_price: "1000", // goods_price 商品信息价格，参数goods=1的情况有效
      goods_url: "https://item.m.jd.com/product/12172344.html", // goods_url 商品信息网址，参数goods=1的情况有效
      goods_imageUrl:
        "https://bytedesk.oss-cn-shenzhen.aliyuncs.com/images/123.webp", // goods_imageUrl 商品图片，参数goods=1的情况有效
      goods_categoryCode: "123", // goods_categoryCode 可选，商品信息类别，参数goods=1的情况有效
      // 自动弹窗，请求后台弹窗目前有点问题，暂时使用前端弹窗设置
      autoPop: false,
      // 语言
      lang: "zh",
      //
      agents: [],
      workGroups: [],
      // 本地测试环境
      isDebug: true,
      baseUrl: "http://127.0.0.1:8000",
      chatUrl: "http://127.0.0.1:8887",
      // 线上环境
      // isDebug: false,
      // baseUrl: 'https://api.bytedesk.com',
      // chatUrl: 'https://chat.kakubaba.com'
    };
  },
  computed: {
    bigWinCode() {
      return (
        this.chatUrl +
        "/chat/pc/index.html?sub=" +
        this.subDomain +
        "&uid=" +
        this.adminUid +
        "&wid=" +
        this.workGroupWid +
        "&type=" +
        this.type +
        "&aid=" +
        this.agentUid +
        "&history=" +
        this.history +
        "&lang=" +
        this.lang +
        "&color=" +
        encodeURIComponent(this.buttonColor) +
        "&background=" +
        encodeURIComponent(this.buttonBackground) +
        "&column=" +
        (this.column === "two" ? "2" : "1") +
        (this.selfDefine
          ? "&username=" +
            this.username +
            "&nickname=" +
            encodeURIComponent(this.nickname) +
            "&avatar=" +
            this.avatar
          : "") +
        (this.showGoods
          ? "&goods=1" +
            "&goods_id=" +
            this.goods_id +
            "&goods_title=" +
            this.goods_title +
            "&goods_content=" +
            this.goods_content +
            "&goods_price=" +
            this.goods_price +
            "&goods_url=" +
            this.goods_url +
            "&goods_imageUrl=" +
            this.goods_imageUrl +
            "&goods_categoryCode=" +
            this.goods_categoryCode
          : "") +
        "&p"
      );
    },
    smallWinCode() {
      return (
        this.chatUrl +
        "/chat/pc/iframe.html?sub=" +
        this.subDomain +
        "&uid=" +
        this.adminUid +
        "&wid=" +
        this.workGroupWid +
        "&type=" +
        this.type +
        "&aid=" +
        this.agentUid +
        "&history=" +
        this.history +
        "&lang=" +
        this.lang +
        "&color=" +
        encodeURIComponent(this.buttonColor) +
        "&background=" +
        encodeURIComponent(this.buttonBackground) +
        "&column=" +
        (this.column === "two" ? "2" : "1") +
        (this.selfDefine
          ? "&username=" +
            this.username +
            "&nickname=" +
            encodeURIComponent(this.nickname) +
            "&avatar=" +
            this.avatar
          : "") +
        (this.showGoods
          ? "&goods=1" +
            "&goods_id=" +
            this.goods_id +
            "&goods_title=" +
            this.goods_title +
            "&goods_content=" +
            this.goods_content +
            "&goods_price=" +
            this.goods_price +
            "&goods_url=" +
            this.goods_url +
            "&goods_imageUrl=" +
            this.goods_imageUrl +
            "&goods_categoryCode=" +
            this.goods_categoryCode
          : "") +
        "&p"
      );
    },
    h5Code() {
      return (
        this.chatUrl +
        "/chat/h5/index.html?sub=" +
        this.subDomain +
        "&uid=" +
        this.adminUid +
        "&wid=" +
        this.workGroupWid +
        "&type=" +
        this.type +
        "&aid=" +
        this.agentUid +
        "&history=" +
        this.history +
        "&lang=" +
        this.lang +
        (this.selfDefine
          ? "&username=" +
            this.username +
            "&nickname=" +
            encodeURIComponent(this.nickname) +
            "&avatar=" +
            this.avatar
          : "") +
        (this.showGoods
          ? "&goods=1" +
            "&goods_id=" +
            this.goods_id +
            "&goods_title=" +
            this.goods_title +
            "&goods_content=" +
            this.goods_content +
            "&goods_price=" +
            this.goods_price +
            "&goods_url=" +
            this.goods_url +
            "&goods_imageUrl=" +
            this.goods_imageUrl +
            "&goods_categoryCode=" +
            this.goods_categoryCode
          : "") +
        "&p"
      );
    },
    embedCode() {
      return (
        "<!--萝卜丝·智能客服代码 开始 -->\n" +
        '<script src="https://cdn.kefux.com/chat/pc/js/custom.min.js?v=20220338"><' +
        "/script>\n" +
        "<script>\n" +
        ' byteDesk.start("' +
        this.lang +
        '", {\n' +
        "   style: " +
        this.style +
        ",\n" +
        '   border: "' +
        this.border +
        '",\n' +
        '   shape: "' +
        this.shape +
        '",\n' +
        '   column: "' +
        this.column +
        '",\n' +
        '   history: "' +
        this.history +
        '",\n' +
        "   autoPop: " +
        this.autoPop +
        ",\n" +
        '   position: "' +
        this.position +
        '",\n' +
        '   margin: "' +
        (this.position === "left" ? this.leftMargin : this.rightMargin) +
        '",\n' +
        '   bottomMargin: "' +
        this.bottomMargin +
        '",\n' +
        '   bannerBackground: "' +
        this.buttonBackground +
        '",\n' +
        '   bannerColor: "' +
        this.buttonColor +
        '",\n' +
        '   buttonColor: "' +
        this.buttonColor +
        '",\n' +
        '   buttonBackground: "' +
        this.buttonBackground +
        '",\n' +
        '   buttonText: "' +
        this.buttonText +
        '",\n' +
        // 客服参数
        '   adminUid: "' +
        this.adminUid +
        '",\n' +
        '   subDomain: "' +
        this.subDomain +
        '",\n' +
        '   type: "' +
        this.type +
        '",\n' +
        '   workGroupWid: "' +
        this.workGroupWid +
        '",\n' +
        '   agentUid: "' +
        this.agentUid +
        '",\n' +
        // 自定义用户名、昵称、头像
        '   username: "' +
        (this.selfDefine ? this.username : "") +
        '",\n' +
        '   nickname: "' +
        (this.selfDefine ? this.nickname : "") +
        '", \n' +
        '   avatar: "' +
        (this.selfDefine ? this.avatar : "") +
        '",\n' +
        "});\n " +
        "<" +
        "/script>\n" +
        "<!--./萝卜丝·智能客服代码 结束 -->"
      );
    },
  },
  watch: {
    buttonColor(newVal, oldVal) {
      // console.log(`buttonColor changed: ${newVal}`);
      this.reinit();
    },
    buttonBackground(newVal, oldVal) {
      // console.log(`buttonBackground changed: ${newVal}`);
      this.reinit();
    },
  },
  methods: {
    init() {
      if (this.agentUid === "" || this.workGroupWid === "") {
        return;
      }
      //
      byteDesk.start(this.lang, {
        style: this.style, // 三个值可选：1,2,3
        border: this.border,
        shape: this.shape,
        column: this.column,
        history: this.history,
        autoPop: this.autoPop,
        position: this.position,
        margin: this.position === "left" ? this.leftMargin : this.rightMargin,
        bottomMargin: this.bottomMargin,
        bannerBackground: this.buttonBackground,
        bannerColor: this.buttonColor,
        buttonColor: this.buttonColor,
        buttonBackground: this.buttonBackground,
        buttonText: this.buttonText,
        // 客服参数
        adminUid: this.adminUid,
        subDomain: this.subDomain,
        type: this.type,
        workGroupWid: this.workGroupWid,
        agentUid: this.agentUid,
        // 自定义用户名、昵称、头像
        username: this.selfDefine ? this.username : "",
        nickname: this.selfDefine ? this.nickname : "",
        avatar: this.selfDefine ? this.avatar : "",
      });
    },

    reinit() {
      byteDesk.removeDOMElements();
      this.init();
      // byteDesk.render()
    },

    getAllAgents() {
      var app = this;
      $.ajax({
        url: this.baseUrl + "/visitor/api/agent/all",
        contentType: "application/json; charset=utf-8",
        type: "get",
        data: {
          uid: this.adminUid,
          client: "web",
        },
        success: function(response) {
          // console.log("get all agents success:", response.data);
          app.agents = response.data;
          for (let i = 0; i < app.agents.length; i++) {
            let user = app.agents[i];
            if (user.robot || user.username === "bytedesk_notification") {
              app.agents.splice(i, 1);
            }
          }
          app.agentUid = app.agents[0].uid;
          // console.log('agentUid:', app.agentUid)
          app.init();
        },
        error: function(error) {
          console.log("get all agents error:", error);
        },
      });
    },

    getAllWorkGroups() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      //
      var app = this;
      $.ajax({
        url: this.baseUrl + "/visitor/api/workGroup/all",
        contentType: "application/json; charset=utf-8",
        type: "get",
        data: {
          uid: this.adminUid,
          client: "web",
        },
        success: function(response) {
          loading.close();
          // console.log("get all workGroup success:", response.data);
          app.workGroups = response.data;
          app.workGroupWid = app.workGroups[0].wid;
          // console.log('workGroupWid:', app.workGroupWid)
          app.init();
        },
        error: function(error) {
          console.log("get all workGroup error:", error);
        },
      });
    },

    getBaseUrl() {
      if (this.isDebug) {
        return;
      }
      let app = this;
      $.ajax({
        url: this.baseUrl + "/visitor/api/wechatUrl",
        contentType: "application/json; charset=utf-8",
        type: "get",
        data: {
          client: "web",
        },
        success: function(response) {
          app.chatUrl = "https://" + response.data.url;
          // const ip = response.data.ip
        },
        error: function(error) {
          console.log("get all workGroup error:", error);
        },
      });
    },

    openWindowBig() {
      window.open(this.bigWinCode);
    },

    openWindowBig2() {
      window.open(
        this.bigWinCode,
        "",
        "height=800, width=800, top=50, left=50, toolbar=no, menubar=no,scrollbars = no, resizable = no, location = no, status = no"
      );
    },

    openWindowSmall() {
      window.open(this.smallWinCode);
    },

    openWindowSmall2() {
      window.open(
        this.smallWinCode,
        "",
        "height=800, width=800, top=50, left=50, toolbar=no, menubar=no,scrollbars = no, resizable = no, location = no, status = no"
      );
    },

    openH5() {
      window.open(this.h5Code);
    },

    openH52() {
      window.open(
        this.h5Code,
        "",
        "height=500, width=400, top=50, left=50, toolbar=no, menubar=no,scrollbars = no, resizable = no, location = no, status = no"
      );
    },

    handleOnCodeEmbedCopy() {
      // console.log('embedcode copy')
      var clipboard = new ClipboardJS(".copyEmbedBtn");
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        // clipboard.destroy()
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        // clipboard.destroy()
        e.clearSelection();
      });
    },

    handleOnCodeBigCopy() {
      // console.log('codebig copy')
      var clipboard = new ClipboardJS(".copyBigBtn");
      clipboard.on("success", (e) => {
        // this.$message.success('复制成功')
        // 释放内存
        // clipboard.destroy()
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        // this.$message.error('该浏览器不支持自动复制')
        // 释放内存
        // clipboard.destroy()
        e.clearSelection();
      });
    },

    handleOnCodeSmallCopy() {
      // console.log('codesmall copy')
      var clipboard = new ClipboardJS(".copySmallBtn");
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        // clipboard.destroy()
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        // clipboard.destroy()
        e.clearSelection();
      });
    },

    handleOnCodeH5Copy() {
      // console.log('codeh5 copy')
      var clipboard = new ClipboardJS(".copyH5Btn");
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        // clipboard.destroy()
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        // clipboard.destroy()
        e.clearSelection();
      });
    },

    switchTestUser(newValue) {
      console.log("switchTestUser:" + newValue);
      if (newValue === "boy") {
        this.username = "mywebuserboy";
        this.nickname = "我是帅哥web";
        this.avatar =
          "https://bytedesk.oss-cn-shenzhen.aliyuncs.com/avatars/boy.png";
      } else {
        this.username = "mywebusergirl";
        this.nickname = "我是美女web";
        this.avatar =
          "https://bytedesk.oss-cn-shenzhen.aliyuncs.com/avatars/girl.png";
      }
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg); //匹配目标参数
      if (r != null) return decodeURIComponent(r[2]);
      return null; //返回参数值
    },
  },
  mounted() {
    //
    // this.adminUid = this.getUrlParam('uid')
    // this.subDomain = this.getUrlParam('sub')
    // // console.log('uid:', this.uid, ' sub:', this.subDomain)
    // //
    // this.getAllAgents()
    // this.getAllWorkGroups()
    // this.getBaseUrl()
  },
};
</script>

<style scoped>
#bd-custom {
  height: 100%;
  overflow-y: scroll;
  text-align: left;
}
</style>
